import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
// import { getInOutsEmployeeList, createEmployeeTimbratura, deleteEmployeeTimbratura, updateEmployeeTimbratura } from '../services/api_timbrature';
import { getTimbrature } from "../../services/api_dipendenti";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { MapPinIcon } from '@heroicons/react/24/solid';
import Swal from "sweetalert2";
import moment from "moment";
import LocationModal from '../../components/location_modal';
import Empty from '../../components/empty';
import { Popover } from '@headlessui/react';
import Fetching from "../../components/fetching";
import Footer from "../../components/footer";




const mesiInItaliano = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
]


export default function TimbraturaCalendar() {
  const { token } = useContext(AuthContext);
  const [timbrature, setTimbrature] = useState({});
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [timbraturaTimeCheckIn, setTimbraturaTimeChecKIn] = useState('');
  const [timbraturaTimeCheckOut, setTimbraturaTimeChecKOut] = useState('');
  const [selectedTimbratura, setSelectedTimbratura] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [weekInfo, setWeekInfo] = useState({});
  

  // const fetchData = async (selectedDay = day) => {
  //   const startOfMonth = moment(selectedDay).startOf('month').format('YYYY-MM-DD');
  //   const endOfMonth = moment(selectedDay).endOf('month').format('YYYY-MM-DD');
  
  //   setLoading(true);
  //   try {
  //     const response = await getTimbrature(
  //       token,
  //       startOfMonth,
  //       1,
  //       100,
  //       endOfMonth
  //     );
  
  //     const mappedTimbrature = response.results.reduce((acc, record) => {
  //       const date = moment(record.checkin).format('YYYY-MM-DD');
  //       if (!acc[date]) {
  //         acc[date] = [];
  //       }
  //       acc[date].push(record);
  //       return acc;
  //     }, {});
  
  //     setTimbrature(mappedTimbrature);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Errore nel recupero delle timbrature:', error);
  //     setLoading(false);
  //   }
  // };  


  const fetchData = async (realday = day) => {
    const startOfMonth = moment(realday).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(realday).endOf('month').format('YYYY-MM-DD');
  
    setWeekInfo({ startOfMonth, endOfMonth });
    setLoading(true);
  
    try {
      const shiftsResponse = await getTimbrature(token, { start: startOfMonth, end: endOfMonth });     
  
      const mappedTimbrature = shiftsResponse.results.reduce((acc, record) => {
        const date = moment(record.checkin).format('YYYY-MM-DD');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(record);
        return acc;
      }, {});
  
      setTimbrature(mappedTimbrature);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      const detail = error.response?.data?.detail;
      const status = error.response?.status;

      if (
        status === 403
      ) {
        Swal.fire({
          icon: 'warning',
          title: 'Accesso negato',
          text: detail,
        });

        const today = moment();
        setDay(today.toDate());
        fetchData(today.toDate());
        return;
      }

      console.error('Errore nel recupero delle timbrature:', error);
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: detail || 'Si è verificato un errore durante il caricamento delle timbrature.',
      });
    }
  }

  useEffect(() => {
    fetchData();
  }, [day]);

  const nextMonth = () => {
    setDay(moment(day).add(1, 'month').toDate());
  };

  const prevMonth = () => {
    setDay(moment(day).subtract(1, 'month').toDate());
  };

  const setOggi = () => {
    setDay(new Date());
  };

  const openModal = (date) => {
    setSelectedDate(date);
    setShowModal(true);
  };
  
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-grow pb-8">
        <Popover as="header" className={`bg-indigo-200`}>
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
              <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                <div className="flex justify-center my-2 py-2">
                  <h2 className="text-center text-2xl font-semibold text-indigo-800">Le mie timbrature</h2>
                </div>
              </div>
            </div>
          </div>
        </Popover>

        <main className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-8">
          <section className="pb-6">
            <div className="flex flex-col rounded-xl border border-gray-300 bg-white px-4 pb-4 pt-4 sm:px-5 sm:pt-5">
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="min-w-0">
                  <h3 className="text-base font-semibold uppercase text-indigo-800">Le mie timbrature</h3>
                  <p className="mt-1 text-xs text-gray-500">
                    Visualizza le timbrature registrate nel mese selezionato
                  </p>
                </div>

                <div className="flex flex-wrap items-center justify-start gap-2 sm:justify-end">
                  <div className="inline-flex max-w-full items-center overflow-hidden rounded-lg border border-indigo-200 bg-white shadow-sm">
                    <button
                      type="button"
                      onClick={prevMonth}
                      title="Mese precedente"
                      className="flex h-10 w-10 shrink-0 items-center justify-center bg-indigo-50 text-indigo-700 transition-colors hover:bg-indigo-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500"
                    >
                      <span className="sr-only">Mese Precedente</span>
                      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <button type="button" onClick={setOggi} title="Torna al mese corrente" className="flex h-10 min-w-[9.5rem] items-center justify-center border-x border-indigo-200 px-4 text-sm font-semibold capitalize text-indigo-800 transition-colors hover:bg-indigo-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500">
                      {mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY')}
                    </button>
                    <button
                      type="button"
                      onClick={nextMonth}
                      title="Mese successivo"
                      className="flex h-10 w-10 shrink-0 items-center justify-center bg-indigo-50 text-indigo-700 transition-colors hover:bg-indigo-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500"
                    >
                      <span className="sr-only">Mese successivo</span>
                      <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 011.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CARICAMENTO */}
          {loading ? (
            <div className="pt-4">
              <Fetching />
            </div>
          ) : (
            <section className="overflow-hidden rounded-xl border border-gray-300 bg-white">
              <div className="min-w-0 overflow-x-auto">
                {!(!timbrature || Object.keys(timbrature).length === 0) ? (
                  <Calendar 
                    day={day} 
                    timbrature={timbrature}
                    openModal={openModal}
                  />
                ) : (
                  <div className="p-4">
                    <Empty />
                  </div>
                )}
              </div>
            </section>
          )}
        </main>
      </div>
      <Footer />
    </div>
  );
}

const Calendar = ({ day, timbrature, openModal }) => {
  const [isModalLocationOpen, setIsModalLocationOpen] = useState(false);
  const [modalLocations, setModalLocations] = useState([]);

  const getDayOfWeek = (dateString) => {
    const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
    return days[new Date(dateString).getDay()];
  };

  const getDaysOfMonth = (date) => {
    const startOfMonth = moment(date).startOf('month');
    const endOfMonth = moment(date).endOf('month');
    const days = [];
    let currentDay = startOfMonth;

    while (currentDay.isSameOrBefore(endOfMonth)) {
      days.push(currentDay.clone());
      currentDay = currentDay.add(1, 'day');
    }
    return days;
  };

  const daysInMonth = getDaysOfMonth(day);

  const handleOpenMap = (locations) => {
    if (locations.length === 0) {
      setModalLocations(null);
    } else {
      setModalLocations(locations);
    }
    setIsModalLocationOpen(true);
  };

  const handleCloseMap = () => {
    setIsModalLocationOpen(false);
    setModalLocations([]);
  };


  return (
    <div className="container mx-auto p-4 rounded-lg">
      <div className="flex flex-col">
        {daysInMonth.map((currentDay) => {
          const dateKey = currentDay.format('YYYY-MM-DD');
          const dayTimbrature = timbrature[dateKey] || [];

          return (
          <div key={currentDay.format('YYYY-MM-DD')} className="flex items-center border-b border-gray-300 py-2">
            <div className="w-1/6 pe-4">
              <div>
                <div className="text-lg font-semibold">{currentDay.format('DD')}</div>
                <div className="text-sm text-gray-500">{getDayOfWeek(currentDay.format('YYYY-MM-DD'))}</div>
              </div>
            </div>
            <div className="w-5/6 flex flex-col">
              {timbrature[currentDay.format('YYYY-MM-DD')] ? (
                timbrature[currentDay.format('YYYY-MM-DD')]
                  .sort((a, b) => {
                    const checkinA = moment(a.checkin);
                    const checkinB = moment(b.checkin);
                    return checkinA.isBefore(checkinB) ? -1 : 1;
                  })
                  .map((timbratura, index) => {
                    const locations = [];
                    if (timbratura.checkin_lat && timbratura.checkin_lng) {
                      locations.push({
                        latitude: timbratura.checkin_lat,
                        longitude: timbratura.checkin_lng,
                        accuracy: timbratura.checkin_accuracy || 50,
                        type: 'checkin',
                      });
                    }
                    if (timbratura.checkout_lat && timbratura.checkout_lng) {
                      locations.push({
                        latitude: timbratura.checkout_lat,
                        longitude: timbratura.checkout_lng,
                        accuracy: timbratura.checkout_accuracy || 50,
                        type: 'checkout',
                      });
                    }
                    return (
                    <div key={index} className="flex items-center justify-between bg-gray-100 border rounded-md p-2 mb-2">
                      <div className="text-sm">
                        <span className="font-semibold">Entrata</span> {timbratura.checkin ? moment(timbratura.checkin).format('HH:mm') : ''} <br />
                        <span className="font-semibold">Uscita</span> {timbratura.checkout ? moment(timbratura.checkout).format('HH:mm') : ''} <br />
                        <span className="font-semibold align-items me-1">Posizione Timbratura </span>
                        <MapPinIcon
                          className="inline-block h-5 w-5 mb-1 cursor-pointer text-indigo-600"
                          onClick={() => handleOpenMap(locations)}
                        />
                        <br />
                      </div>
                    </div>
                  )})
              ) : (
                <div className="text-sm text-gray-500">Nessuna registrazione</div>
              )}
            </div>
          </div>
          );}

        )}
        {isModalLocationOpen && (
          <LocationModal
            isOpen={isModalLocationOpen}
            onClose={handleCloseMap}
            locations={modalLocations}
          />
        )}
      </div>
    </div>
  );
};
